import { useState } from "react";
import { InputLabel, TextField } from "@material-ui/core";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import styles from "./Login.module.scss";
import Logo from "../../assets/images/new-logo.svg";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
	closeLoader,
	openLoader,
} from "../../redux/actions/loader/loaderActions";
import { openToastAndSetContent } from "../../redux/actions/toast/toastActions";
import axios from "axios";

const LoginPasswordReset = () => {
	const history = useHistory();
	const dispatch = useDispatch();

	const validate = Yup.object({
		email: Yup.string()
			.email("Email is invalid")
			.required("Email Address is required"),
		password: Yup.string()
			.min(6, "Password must be at least 6 charaters")
			.required("Password is required"),

		currentPassword: Yup.string()
			.min(3, "Password too short")
			.required("Please enter password again"),
	});

	const { email }: any = history?.location.state;

	const [seeFirst, setSeeFirst] = useState(false);
	const [seeSecond, setSeeSecond] = useState(false);

	const handleSeeFirst = () => {
		setSeeFirst(!seeFirst);
	};
	const handleSeeSecond = () => {
		setSeeSecond(!seeSecond);
	};

	return (
		<Formik
			initialValues={{
				email,
				currentPassword: "",
				password: "",
			}}
			validationSchema={validate}
			onSubmit={(values) => {
				dispatch(openLoader());

				axios
					.post("/auth/password/change/force", values)
					.then((res: any) => {
						dispatch(closeLoader());
						dispatch(
							openToastAndSetContent({
								toastContent: res?.data?.message,
								toastType: "success",
							})
						);

						history.push("/signin");
					})
					.catch((err: any) => {
						dispatch(closeLoader());
						dispatch(
							openToastAndSetContent({
								toastContent: err?.response?.data?.message || err.message,
								toastType: "error",
							})
						);
					});
			}}
		>
			{(props) => (
				<div className={styles.signinContainer}>
					<div className={styles.logo}>
						<img src={Logo} alt="logo" />
						<h3>Admin</h3>
					</div>
					<div className={styles.mt1}>
						<div className={styles.signinDiv}>
							<div className={styles.signinHeader}>
								<h5 className={styles.headerH}>New Password</h5>
								<p className={styles.mt1} />
								<p className={styles.headerP}>
									let’s set up a new password for your account
								</p>
							</div>
							<div className={styles.mt2}>
								<Form>
									<InputLabel>
										<span className={styles.formTitle}>Current Password</span>
									</InputLabel>
									<div className={styles.password}>
										<Field
											as={TextField}
											helperText={
												<ErrorMessage name="currentPassword">
													{(msg) => <span style={{ color: "red" }}>{msg}</span>}
												</ErrorMessage>
											}
											name="currentPassword"
											placeholder="******"
											variant="outlined"
											margin="normal"
											type={`${seeFirst ? "text" : "password"}`}
											size="small"
											fullWidth
										/>
										<span onClick={handleSeeFirst} className={styles.eyeIcon}>
											{seeFirst ? <VisibilityIcon /> : <VisibilityOffIcon />}
										</span>
									</div>

									<InputLabel>
										<span className={styles.formTitle}>New Password</span>
									</InputLabel>
									<div className={styles.password}>
										<Field
											as={TextField}
											helperText={
												<ErrorMessage name="confirm_password">
													{(msg) => <span style={{ color: "red" }}>{msg}</span>}
												</ErrorMessage>
											}
											name="password"
											placeholder="*******"
											variant="outlined"
											margin="normal"
											type={`${seeSecond ? "text" : "password"}`}
											size="small"
											fullWidth
										/>
										<span onClick={handleSeeSecond} className={styles.eyeIcon}>
											{seeSecond ? <VisibilityIcon /> : <VisibilityOffIcon />}
										</span>
									</div>
									<InputLabel className={styles.mt1}></InputLabel>
									<button
										className={styles.submit}
										type="submit"
										color="primary"
									>
										Change Password
									</button>
								</Form>
							</div>
						</div>
					</div>

					<div className={styles.sub}>
						<p className={styles.mt2}>
							<span className={styles.subP}>
								<span className={styles.desc}>
									Changed your password already?{" "}
								</span>
								<a
									onClick={() => history.push("/signin")}
									className={styles.signinAnchor}
								>
									Back to Login
								</a>
							</span>
						</p>
					</div>
				</div>
			)}
		</Formik>
	);
};

export default LoginPasswordReset;
